import React, { FunctionComponent } from 'react';
import { Header as BrHeader, Logo as BronsonLogo } from '@vwfs-bronson/bronson-react';

const Header: FunctionComponent = () => {
  const Logo = function Logo() {
    console.log(process.env.REACT_APP_LOGO_URL);
    return (
      <BronsonLogo
        custom={Boolean(process.env.REACT_APP_LOGO_URL)}
        src={process.env.REACT_APP_LOGO_URL || ''}
        ariaLabel="Logo"
        tabIndex={0}
        title="VWFS TCO"
      />
    );
  };

  return (
    <>
      <BrHeader testId="appHeader" staticHeader logo={<Logo />}></BrHeader>
    </>
  );
};

export default Header;
